module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-160.259d703.woff2";